var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isActive && _vm.isAnimate ? 'pl-count pl-count--light' : 'pl-count'},[_vm._v(" "+_vm._s(_vm.formattedHours + ':' + _vm.formattedMinutes + ':' + _vm.formattedSeconds)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }